export const windowSize = [
  {
    label: 'Desktop',
    value: 0
  },
  {
    label: 'Mobile',
    value: 1,
  },
]